export default "__VITE_ASSET__FR_KVH1S__"